/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createDisease = /* GraphQL */ `
  mutation CreateDisease(
    $input: CreateDiseaseInput!
    $condition: ModelDiseaseConditionInput
  ) {
    createDisease(input: $input, condition: $condition) {
      normalizedName
      name
      owner
      description
      removed
      gsiPartition
      createdAt
      updatedAt
      symptoms
      reviews {
        nextToken
      }
    }
  }
`;
export const updateDisease = /* GraphQL */ `
  mutation UpdateDisease(
    $input: UpdateDiseaseInput!
    $condition: ModelDiseaseConditionInput
  ) {
    updateDisease(input: $input, condition: $condition) {
      normalizedName
      name
      owner
      description
      removed
      gsiPartition
      createdAt
      updatedAt
      symptoms
      reviews {
        nextToken
      }
    }
  }
`;
export const deleteDisease = /* GraphQL */ `
  mutation DeleteDisease(
    $input: DeleteDiseaseInput!
    $condition: ModelDiseaseConditionInput
  ) {
    deleteDisease(input: $input, condition: $condition) {
      normalizedName
      name
      owner
      description
      removed
      gsiPartition
      createdAt
      updatedAt
      symptoms
      reviews {
        nextToken
      }
    }
  }
`;
export const createReview = /* GraphQL */ `
  mutation CreateReview(
    $input: CreateReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    createReview(input: $input, condition: $condition) {
      id
      diseaseNormalizedName
      owner
      rating
      comment
      createdAt
      updatedAt
      disease {
        normalizedName
        name
        owner
        description
        removed
        gsiPartition
        createdAt
        updatedAt
        symptoms
      }
    }
  }
`;
export const updateReview = /* GraphQL */ `
  mutation UpdateReview(
    $input: UpdateReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    updateReview(input: $input, condition: $condition) {
      id
      diseaseNormalizedName
      owner
      rating
      comment
      createdAt
      updatedAt
      disease {
        normalizedName
        name
        owner
        description
        removed
        gsiPartition
        createdAt
        updatedAt
        symptoms
      }
    }
  }
`;
export const deleteReview = /* GraphQL */ `
  mutation DeleteReview(
    $input: DeleteReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    deleteReview(input: $input, condition: $condition) {
      id
      diseaseNormalizedName
      owner
      rating
      comment
      createdAt
      updatedAt
      disease {
        normalizedName
        name
        owner
        description
        removed
        gsiPartition
        createdAt
        updatedAt
        symptoms
      }
    }
  }
`;
